import { Dashboard } from "components/Layout";
import React, { useCallback, useEffect, useState } from "react";
import { RouteComponentProps } from "react-router-dom";
import api from "api/api";
import StoreProvider from "components/StoreProvider/StoreProvider";
import { OrganizationType } from "store/modules/organizations/organizations";
import { compose } from "ramda";
import queryString from "query-string";
import RouterProvider from "components/RouterProvider/RouterProvider";
import ProductList from "components/OrganizationAdmin/Products/ProductsList";
import { ProductType } from "./types";
import { useFormatMessage } from "components/IntlProvider";

const { ROUTES } = RouterProvider;

const { connect, selectors } = StoreProvider;
export const defaultLimit = 20;

type ProjectListResponse = {
  count: number;
  results: ProductType[];
};

interface Props extends RouteComponentProps {
  organization: OrganizationType;
}

const ProductssPage = ({ location, organization, history }: Props) => {
  const [products, setProducts] = useState<ProjectListResponse>({
    count: 0,
    results: [],
  });

  const [isLoaded, setIsLoaded] = useState(false);
  const parsedSearch = queryString.parse(location.search);
  const t = useFormatMessage();

  const getProducts = () =>
    api.resources.organization.products
      .getProducts({
        organizationCodename: organization.codename,
        params: {
          limit: (parsedSearch.limit as string) || defaultLimit,
          offset: (parsedSearch.offset as string) || 0,
          search: (parsedSearch.search as string) || undefined,
          ordering: (parsedSearch.ordering as string) || undefined,
        },
      })
      .then(({ data }: { data: ProjectListResponse }) => {
        setProducts({ ...data });
      })
      .finally(() => {
        setIsLoaded(true);
      });

  useEffect(() => {
    if (location.search) {
      setIsLoaded(false);
      getProducts();
    }
    // eslint-disable-next-line
  }, [location.search]);

  const getPageNumber = useCallback(() => {
    if (parsedSearch.offset && !Array.isArray(parsedSearch.offset)) {
      return Math.floor(parseInt(parsedSearch.offset, 10) / defaultLimit + 1);
    }

    return 0;
  }, [parsedSearch]);

  const sortColumns = (colName: string) => {
    const params = { ...parsedSearch, ordering: colName };

    history.push(
      `${ROUTES.ORGANIZATION.ADMIN.PRODUCTS}?${queryString.stringify(params)}`
    );
  };
  return (
    <Dashboard title={t("dashboard.menu.admin", "Admin")} location={location}>
      <ProductList
        isLoaded={isLoaded}
        count={products.count}
        currentPage={getPageNumber()}
        sortColumns={sortColumns}
        orderBy={parsedSearch.ordering as string}
        products={products.results}
      />
    </Dashboard>
  );
};

export default compose(
  connect((state) => ({
    organization: selectors.authSelectors.userOrganization(state),
    isAdmin: selectors.authSelectors.isOrganizationAdmin(state),
  }))
)(ProductssPage);
